<template>
  <div>
    <div class="page_title">
      提现管理
    </div>
    <div style="padding:20px;">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>分销员</span>
            <el-input
              v-model="nick_name"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>手机号</span>
            <el-input
              v-model="phone"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>提现时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:225px; margin-left: 6px"
              @change="search"
            >
            </el-date-picker>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981; margin-left: 6px"
              @click="search"
            >查询</el-button>
          </div>
          <div class="item">
            <span>提现状态</span>
            <el-radio-group
              v-model="status"
              style="margin-left: 6px"
              @change="search"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">待审核</el-radio>
              <el-radio :label="2">已通过</el-radio>
              <el-radio :label="3">已拒绝</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div
          class="flex_between"
          style="margin-bottom:10px"
        >
          <el-button
            type="primary"
            @click="excelexport"
            style="width:92px"
            size="medium"
            :disabled="
                module_id_array[0] ? !module_id_array.includes('960') : false
              "
          >导出</el-button>
          <span>
            <el-button
              type="primary"
              @click="checkApplyAll(3)"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('962') : false
              "
            >批量退回</el-button>
            <el-button
              type="primary"
              @click="checkApplyAll(2)"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('962') : false
              "
            >批量确认</el-button>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              label="分销员"
              prop="user_name"
            >
            </el-table-column>
            <el-table-column
              label="手机号"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="提现金额"
              prop="ca_money"
            ></el-table-column>
            <el-table-column
              label="提现手续费"
              prop="service_charge"
            ></el-table-column>
            <el-table-column
              label="实付金额"
              prop="pay_money"
            ></el-table-column>
            <el-table-column
              label="提现时间"
              prop="create_time"
            ></el-table-column>
            <el-table-column label="提现状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status==1">待审核</span>
                <span v-if="scope.row.status==2">已通过</span>
                <span v-if="scope.row.status==3">已拒绝</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status==1"
                  type="text"
                  @click="checkApply(scope.row.ca_id,3)"
                  :disabled="
                module_id_array[0] ? !module_id_array.includes('961') : false
              "
                >退回</el-button>
                <el-button
                  v-if="scope.row.status==1"
                  type="text"
                  @click="checkApply(scope.row.ca_id,2)"
                  :disabled="
                module_id_array[0] ? !module_id_array.includes('961') : false
              "
                >确认</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      phone: '',
      nick_name: '',
      date: [],
      status: 0,
      ca_ids: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        phone: this.phone,
        nick_name: this.nick_name,
        status: this.status
      };
      if (this.date && this.date.length) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios.post('platform/Distribution/cashOutList', data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //导出数据
    excelexport() {
      let loading = this.$loading();
      let data = {
        phone: this.phone,
        nick_name: this.nick_name,
        order_value: this.order_value
      };
      if (this.date && this.date.length) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Distribution/exportCashout', data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              '//' +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //多选
    handleSelectionChange(val) {
      let arr = val.map((item) => {
        return item.ca_id;
      });
      this.ca_ids = arr.toString();
    },
    //退回/确认
    checkApply(ca_id, status) {
      let loading = this.$loading({
        text: '操作正在执行中，请不要关闭或者退出当前页面'
      });
      let msg = '是否同意本次提现？';
      if (status == 3) {
        msg = '是否确认退回，提现金额将退回分销员账户？';
      }
      this.$confirm(`${msg}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            ca_id,
            status
          };
          this.axios
            .post('platform/Distribution/checkStatus', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {
          loading.close();
        });
    },
    //批量退回/确认
    checkApplyAll(status) {
      if (!this.ca_ids) {
        this.$message.error('请先选择需要操作的数据');
        return false;
      }
      let loading = this.$loading({
        text: '操作正在执行中，请不要关闭或者退出当前页面'
      });
      let msg = '是否同意本次提现？';
      if (status == 3) {
        msg = '是否确认退回，提现金额将退回分销员账户？';
      }
      this.$confirm(`${msg}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            ca_ids: this.ca_ids,
            status
          };
          this.axios
            .post('platform/Distribution/batchCheckStatus', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {
          loading.close();
        });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 20px;
  }
}
</style>